import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/56c75172ec6edbbe2f8a5e9c79f7c64569006706/FormsUI/static/js/selectors/Scope.ts#L84
 */
export default function useHasFormV2Scope() {
  const {
    hasScope
  } = useUserInfo();
  return hasScope('forms-v2-temp');
}